import { baseApi } from "../baseApi";

export const GsthsncodeApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDoctypeDetails: builder.query({
            query: (params) => ({
                url: `/api/method/frappe.client.get`,
                params: params
            })
        }),
        getGstHsnCodeList: builder.query({
            query: ({ start, limit, filters = [] }) => ({
                url: `/api/resource/GST HSN Code`,
                params: {
                    fields: JSON.stringify([
                        "`tabGST HSN Code`.`name`",
                        "`tabGST HSN Code`.`owner`",
                        "`tabGST HSN Code`.`creation`",
                        "`tabGST HSN Code`.`modified`",
                        "`tabGST HSN Code`.`modified_by`",
                        "`tabGST HSN Code`.`_user_tags`",
                        "`tabGST HSN Code`.`_comments`",
                        "`tabGST HSN Code`.`_assign`",
                        "`tabGST HSN Code`.`_liked_by`",
                        "`tabGST HSN Code`.`docstatus`",
                        "`tabGST HSN Code`.`idx`",
                        "`tabGST HSN Code`.`hsn_code`",
                        "`tabGST HSN Code`.`description`"
                    ]),
                    order_by: "`tabGST HSN Code`.`modified` desc",
                    limit_start: start,
                    limit_page_length: limit,
                    ...(filters.length > 0 && {
                        filters: JSON.stringify(filters),
                    }),
                }
            }),
            providesTags: ['GstHsnCode'],
        }),
        getGsthsncodeCount: builder.query({
            query: () => ({
                url: '/api/method/frappe.desk.reportview.get_count',
                params: {
                    doctype: 'GST HSN Code',
                },
            }),
        }),
        getItemTaxTemplates: builder.query({
            query: () => {
                const fields = [
                    "`tabItem Tax Template`.`name`",
                ];
                const params = {
                    fields: JSON.stringify(fields),
                    order_by: "`tabItem Tax Template`.`modified` desc",
                };
                return {
                    url: `/api/resource/Item Tax Template`,
                    method: "GET",
                    params,
                };
            },
        }),
        getTaxcategory: builder.query({
            query: () => `/api/resource/Tax Category`,
        }),
        createGstHsnCode: builder.mutation({
            query: (payload) => ({
                url: '/api/resource/GST HSN Code',
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['GstHsnCode'],
        }),
        getGstHsnCodeDetail: builder.query({
            query: (id) => `/api/resource/GST HSN Code/${id}`,
            providesTags: ['GstHsnCode'],
        }),
        updateGstHsnCode: builder.mutation({
            query: ({ id, body }) => ({
                url: `/api/resource/GST HSN Code/${id}`,
                method: 'PUT',
                body,
            }),
             invalidatesTags: ['GstHsnCode'],
        }),
    }),
});


export const { useGetGstHsnCodeListQuery, useGetGsthsncodeCountQuery, useGetItemTaxTemplatesQuery, useGetTaxcategoryQuery, useCreateGstHsnCodeMutation, useGetGstHsnCodeDetailQuery ,useUpdateGstHsnCodeMutation} = GsthsncodeApi
